/**
 * This enum represents all static local storage keys used inside durable.
 * This allows for individual documentation and consistant access.
 */
export enum LocalStorageLocation {
  /** Boolean: Rather the frontend is current in Dark Mode. */
  DarkMode = "darkMode",

  /** Boolean: Rather the node details panel is open. */
  DebugPanelOpen = "debugPanelOpen",

  /** ProfileStore: A store of users who are logged in, and which is active. */
  DurableUsers = "durableUsers",

  /** String[]: The tool ids of the 3 most recent tools. */
  RecentTools = "recentTools",

  /**
   * CodeTemplate[]: Code that has recently been deployed from the
   *  DeployCode devtool
   */
  RecentlyDeployedCode = "recentlyDeployedCode",

  /** Boolean: Rather the chain of proof is displayed on a blueprint. */
  ShowSteps = "showSteps",

  /** Boolean: Rather the node color key is shown on the planner. */
  ShowDebugKey = "showDebugKey",

  /** Boolean: Rather the node search panel is shown on the planner. */
  ShowNodeSearch = "showNodeSearch",

  /** Boolean: Rather non-completable examples should be displayed on start. */
  showForwardLookingExamples = "showForwardLookingExamples",

  /** Boolean: Ingest bulk paths panel open */
  IngestBulkPathsPanelOpen = "ingestBulkPathsPanelOpen",

  /** Boolean: LLM Cost panel open */
  LLMCostPanelOpen = "llmCostPanelOpen"
}
